<template>
  <header>
    有料会員登録
    <div class="h-left">
      <a @click="redirectBack()"><img src="~@/assets/images/icon02.svg" /></a>
    </div>
  </header>
  <div id="wrap" style="padding-bottom: 100px;">
    <img src="~@/assets/images/member01.png" />
    <ul class="txt-area">
      <li>
        <a href="#"><img src="~@/assets/images/m-banner-1m.png" /></a>
      </li>
      <li>
        <a href="#"><img src="~@/assets/images/m-banner-3m.png" /></a>
      </li>
      <li>
        <a href="#"><img src="~@/assets/images/m-banner-6m.png" /></a>
      </li>
      <li>
        <a href="#"><img src="~@/assets/images/m-banner-12m.png" /></a>
      </li>
    </ul>
    <img src="~@/assets/images/member02.png" />
    <img src="~@/assets/images/member03.png" />
    <ul class="txt-area">
      <li>
        <a href="#"><img src="~@/assets/images/m-banner-1m.png" /></a>
      </li>
      <li>
        <a href="#"><img src="~@/assets/images/m-banner-3m.png" /></a>
      </li>
      <li>
        <a href="#"><img src="~@/assets/images/m-banner-6m.png" /></a>
      </li>
      <li>
        <a href="#"><img src="~@/assets/images/m-banner-12m.png" /></a>
      </li>
    </ul>

    <div class="txt-area">
      <p class="b">注意事項</p>
      <p>
        ・複数月プランのお支払いは一括払いのみとなります。分割によりお支払
        いはできませんのでご了承ください。<br/>
        <br/>
        ・料金
        <br/>
        1ヶ月プラン 10,800円(税込)
        <br/>
        3ヶ月プラン 27,800円(税込)
        <br/>
        6ヶ月プラン 48,800円(税込)
        <br/>
        12ヶ月プラン 64,800円(税込)
        <br/>
        <br />
        ・有料会員は1ヶ月、3ヶ月、6ヶ月、12ヶ月ごとの自動継続課金をご用意しております。<br />
        <br />
        ・自動継続課金は期限が切れる24時間以内に自動的に課金される仕組みです。<br />
        <br />
        ・自動継続課金は期限が切れる24時間前に設定からオフにしなければ自動的に更新される仕組みです。<br />
        <br />
        ・更新日前に解約のお手付きをなさった場合、残りの期間についての月割り、日割りでの返金いたしません。<br />
        <br />
        ・現在、ご利用中の有料会員のキャンセルは契約期間が終わったあとにキャンセル処理が行われます。<br />
      </p>

      <p class="b mt12">月額決済が反映されない場合</p>
      <p>
        決済処理の途中で接続状況の悪化などにより、決済が行われたという情報がGreedGreedのシステムまで届かない場合が稀にございます。
      </p>
    </div>
  </div>
</template>

<script>
import {
    mapActions
} from "vuex"
// import CONSTANTS from "@/constants"
export default {
    props: {
      isShow: Boolean
    },
    emits: ['close'],
    mounted() {
        this.setFooter(false)
    },
    methods: {
        ...mapActions({
          setFooter: 'layout/setFooter'
        }),
        redirectBack() {
          if (this.isShow) {
            this.$emit('close')
          } else {
            this.$router.go(-1)
            this.setFooter(true)
          }
        }
    }
}
</script>